import { Page } from '@/app/graphql/generated'
import { IContent } from '@/app/shared/interfaces/content.interface'

export const getDataBySlug = (slug: string, data?: Page | null, isObj?: boolean) => {
  if (!data) return null

  const currentObj = data.blocks?.find((el) => el?.type === slug)

  if (isObj) return currentObj

  return clearData(JSON.parse(currentObj?.contentAll ?? ''))
}

export const isBlockExist = (slug: string, data?: Page | null) => {
  if (!data) return false

  return data.blocks?.some((el) => el?.type === slug)
}

export const getBlock = (slug: string, data?: Page | null) => {
  return data?.blocks?.find((el) => el?.type === slug)
}

type TBlocksData = {
  [key: string]: any
}

export const clearData = (data: IContent[]): TBlocksData => {
  const obj: TBlocksData = {}

  if (!data) return {}

  data.forEach((item) => {
    const sameLayout = data.filter((el) => el.layout === item.layout)

    if (sameLayout.length === 1) {
      const template = clearAttr(item)

      if (template) obj[toCamelCase(item.layout)] = template
    } else if (!obj[item.layout]) {
      obj[toCamelCase(item.layout)] = sameLayout.map((el) => {
        const template = clearAttr(el)

        if (!template) return null

        return template
      })
    }
  })

  return obj
}

const clearAttr = (data: IContent) => {
  const obj: TBlocksData | null = {}

  if (!data) return null

  const { attributes }: Record<string, any> = data

  if (!attributes) return null

  const keys = Object.keys(attributes)

  keys.forEach((attr) => {
    if (Array.isArray(attributes[attr])) clearData(attributes[attr])

    if (typeof attributes[attr] === 'object') clearAttr(attributes[attr])

    obj[toCamelCase(attr)] = attributes[attr]
  })

  return obj
}

function toCamelCase(str: string): string {
  return str
    .replace(/_/g, '-')
    .split('-') // Split the string into parts by '-'
    .map(
      (word, index) =>
        index === 0
          ? word // Keep the first word lowercase
          : word.charAt(0).toUpperCase() + word.slice(1), // Capitalize the first letter of subsequent words
    )
    .join('') // Join the parts back together
}
